import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Assignment, AssignmentIdentity } from '@k2/common/entities-state/types';
import { Backend } from "@k2/common/backend/backend";

@Component({
  selector: 'assignment-details',
  templateUrl: 'assignment-details.component.html',
  styleUrls: ['assignment-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AssignmentDetailsComponent {
  @Input() assignment: Assignment;

  constructor(
    private backend: Backend
  ) {
  }

  syncWithMoveTrack(): void {
    const toPost = {
      is_sent_to_movetrack: this.assignment.is_sent_to_movetrack,
      can_it_be_synced_with_movetrack: this.assignment.can_it_be_synced_with_movetrack
    };

    const assignmentIdentity: AssignmentIdentity = {
      clientId: this.assignment.client.id,
      assignmentId: this.assignment.id
    };

    this.backend.assignmentAnalysis.syncWithMoveTrack(
      assignmentIdentity,
      toPost
    )
      .subscribe();
  }
}
